import { Component } from '@angular/core';
import { Firestore, collection, query, orderBy, limit, collectionData, CollectionReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Timestamp } from '@angular/fire/firestore';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AsyncPipe, JsonPipe, DatePipe } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButton } from '@angular/material/button';

interface ApiError {
  id: string;
  answers: [];
  errorMsg: string;
  apiResponseMessage: unknown;
  createdDate: Timestamp;
}

@Component({
    selector: 'app-api-errors',
    templateUrl: './api-errors.component.html',
    styleUrls: ['./api-errors.component.css'],
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, FormsModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, AsyncPipe, JsonPipe, DatePipe]
})
export class ApiErrorsComponent {
  apiErrors: Observable<ApiError[]>;
  selectedError: ApiError | null = null;
  limit = 30;

  constructor(private firestore: Firestore) {
    this.apiErrors = this.queryErrors();
  }

  getApiErrors() {
    this.apiErrors = this.queryErrors();
  }

  private queryErrors(): Observable<ApiError[]> {
    const errorsCollection = collection(this.firestore, 'apiErrors') as CollectionReference<ApiError>;
    const q = query(errorsCollection, orderBy('createdDate', 'desc'), limit(this.limit));
    return collectionData(q) as Observable<ApiError[]>;
  }

  onSelect(error: ApiError): void {
    this.selectedError = error;
  }

  onLimitChange() {
    if (this.limit > 0 && this.limit <= 1000) {
      this.getApiErrors();
    }
  }

  onClose(): void {
    this.selectedError = null;
  }
}